// The physical scale bar's length and label, for the viewport's corner chip
// and for a snapshot's (viewer/capture/overlays.ts), so the two read alike.

/** How long the bar aims to be on screen, in CSS px. */
export const SCALE_BAR_TARGET_PX = 110;

/** Pick a "nice" bar length (about `targetPx`) and a human label for the given scale. */
export function computeScaleBar(mmPerPixel: number, targetPx = SCALE_BAR_TARGET_PX): { px: number; label: string } {
  const rawMm = targetPx * mmPerPixel;
  const exp = Math.floor(Math.log10(rawMm));
  const base = Math.pow(10, exp);
  const mantissa = rawMm / base;
  const niceMantissa = mantissa >= 5 ? 5 : mantissa >= 2 ? 2 : 1;
  const niceMm = niceMantissa * base;
  const px = Math.round(niceMm / mmPerPixel);
  let label: string;
  if (niceMm < 1) label = `${Math.round(niceMm * 1000)} µm`;
  else if (niceMm < 10) label = `${+niceMm.toFixed(2)} mm`;
  else label = `${Math.round(niceMm)} mm`;
  return { px, label };
}
